import React from "react";
import { Card, FormInput, FormSelect, Button } from "ui-kit-ck-consultant";
import { Row, Col } from "react-flexbox-grid";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const regionOptions = [
  { value: "DEFAULT", text: "Toutes les régions" },
  {
    text: "ILE-DE-FRANCE",
    agencies: [
      { value: "DEFAULT", text: "Toutes les agences" },
      { value: "75;77;78;91;92;93;94;95", text: "VLF 75 + 77" },
    ],
  },
  {
    text: "NORD-EST",
    agencies: [
      { value: "DEFAULT", text: "Toutes les agences" },
      { value: "02;59;60;62;80", text: "VLF 02 + 59" },
    ],
  },
  {
    text: "SUD-OUEST",
    agencies: [
      { value: "DEFAULT", text: "Toutes les agences" },
      { value: "09;11;12;15;19;31;46;66;81;82", text: "VLF 09 + 11" },
      { value: "32;33;40;47;64;65", text: "VLF 32 + 33" },
      {
        value: "09;11;12;15;19;31;32;33;40;46;47;64;65;66;81;82",
        text: "2RF 09 + 11",
      },
    ],
  },
  {
    text: "NORD-OUEST",
    agencies: [
      { value: "DEFAULT", text: "Toutes les agences" },
      {
        value:
          "02;14;22;27;28;29;35;44;49;50;53;56;59;60;61;62;72;75;76;77;78;80;85;91;92;93;94;95",
        text: "2RF 02 + 14",
      },
    ],
  },
];

export default class ShowOptionsAxa extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      region: "DEFAULT",
      agency: "DEFAULT",
      department: "DEFAULT",
      VTHG: "0",
    };
  }

  getDepartments = (state) => {
    if (state.department !== "DEFAULT") {
      return state.department.split(";");
    }

    if (state.agency !== "DEFAULT") {
      return state.agency.split(";");
    }

    if (state.region !== "DEFAULT") {
      let departments = [];
      regionOptions[state.region].agencies.forEach((element) => {
        if (element.value !== "DEFAULT") {
          departments = departments.concat(element.value.split(";"));
        }
      });
      return [...new Set(departments)];
    }

    return null;
  };

  notifyChange = (dateStart, dateEnd, state) => {
    this.props.onFilterChange({
      dateStart,
      dateEnd,
      departments: this.getDepartments(state),
      VTHG: state.VTHG,
    });
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;

    const newState = {
      [name]: value,
      agency:
        name === "region"
          ? "DEFAULT"
          : name === "agency"
            ? value
            : this.state.agency,
      department:
        name === "region" || name === "agency"
          ? "DEFAULT"
          : name === "department"
            ? value
            : this.state.department,
    };

    if (name === "dateStart" || name === "dateEnd") {
      this.notifyChange(
        name === "dateStart" ? value : this.props.dateStart,
        name === "dateEnd" ? value : this.props.dateEnd,
        this.state,
      );
    } else {
      this.setState(newState, () => {
        this.notifyChange(this.props.dateStart, this.props.dateEnd, this.state);
      });
    }
  };

  render() {
    return (
      <Card title="Filtres" className={this.props.className}>
        <Row>
          <Col xs={12} md={4} lg={2}>
            <FormInput
              className="mb-20"
              title="Date de début"
              type="date"
              name="dateStart"
              value={this.props.dateStart}
              onChange={this.handleInputChange}
            />
          </Col>
          <Col xs={12} md={4} lg={2}>
            <FormInput
              className="mb-20"
              title="Date de fin"
              type="date"
              name="dateEnd"
              value={this.props.dateEnd}
              onChange={this.handleInputChange}
            />
          </Col>
          <Col xs={12} md={4} lg={3}>
            <FormSelect
              className="mb-20"
              name="region"
              value={this.state.region}
              options={regionOptions.map((region, idx) => ({
                value: !idx ? "DEFAULT" : idx,
                text: region.text,
              }))}
              title="Région"
              onChange={this.handleInputChange}
              ignore={true}
            />
          </Col>
          <Col xs={12} md={4} lg={3}>
            <FormSelect
              className="mb-20"
              name="agency"
              value={this.state.agency}
              options={
                this.state.region !== "DEFAULT"
                  ? regionOptions[this.state.region].agencies
                  : []
              }
              title="ZI"
              onChange={this.handleInputChange}
              ignore={true}
            />
          </Col>
          <Col xs={12} md={4} lg={2}>
            <FormSelect
              className="mb-20"
              name="department"
              value={this.state.department}
              options={[
                {
                  value: "DEFAULT",
                  text: "Veuillez sélectionner un département",
                },
                ...(this.state.agency !== "DEFAULT"
                  ? this.state.agency.split(";").map((value) => {
                      return {
                        value,
                        text: value,
                      };
                    })
                  : []),
              ]}
              title="Département"
              onChange={this.handleInputChange}
              ignore={true}
            />
          </Col>
          <Col xs={12} md={4} lg={2}>
            <FormSelect
              className="mb-20"
              name="VTHG"
              value={this.state.VTHG}
              options={[
                { value: "0", text: "Non filtré" },
                { value: "1", text: "Oui" },
                { value: "2", text: "Non" },
              ]}
              title="VTHG"
              onChange={this.handleInputChange}
              ignore={true}
            />
          </Col>
        </Row>
        {this.props.getData ? (
          <Row>
            <Col xs={12} className="d-flex mt-auto">
              <Button
                text="Rechercher"
                className="mt-auto mb-20"
                onClick={() => this.props.getData()}
              >
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </Col>
          </Row>
        ) : null}
        {this.props.footerData || null}
      </Card>
    );
  }
}
